import PropTypes from 'prop-types'
import { Box, Typography } from '@material-ui/core'
import { Image } from '@components/atoms'
import ButtonCta from '@components/atoms/button-cta'
import {
  IconFlag,
  IconMarker,
} from '@components/atoms/icons'
import DateRangeNew from '@components/atoms/date-range-new'
import useStyles from './card-major-event.styles'

const CardMajorEvent = (props) => {
  const {
    headline,
    image,
    heroImage,
    course,
    location,
    startDate,
    endDate,
    className,
    logo,
    slug,
    status,
  } = props
  const styles = useStyles()

  const url = (image && image.url) || (heroImage && heroImage.url)

  return (
    <Box className={`${styles.root} ${className}`}>
      <Box className={styles.alignment}>
        <Box className={styles.imageContainer}>
          {url && <Image className={styles.image} src={`${url}?w=420&h=120&fit=fill`} alt={image?.description || headline} />}
          <Box className={styles.tagsRow}>
            <Box className={styles.tagsWrapper}>
              {url && <Typography variant="body2" className={styles.tag}>{status}</Typography>}
            </Box>
          </Box>
          {logo && (
            <Image
              className={styles.logo}
              src={`${logo.url}?fm=jpg&h=200&w=200&fit=fill&fl=progressive&q=80`}
              alt=""
            />
          )}
        </Box>
        <Box className={styles.cardInfo} mb={1}>
          <Box className={styles.dateRange}>
            <DateRangeNew startDate={startDate} endDate={endDate} />
          </Box>
          <Typography variant="h5" variantMapping={{ h5: 'h3' }} className={styles.headline}>{headline}</Typography>
          <div aria-label="event details" role="list">
            {course && (
              <div className={styles.field} role="listitem">
                <IconFlag className={styles.icon} alt="course" />
                <Typography variant="caption" className={styles.fieldText}>{course}</Typography>
              </div>
            )}
            {location && (
              <div className={styles.field} role="listitem">
                <IconMarker className={styles.icon} alt="location" />
                <Typography variant="caption" className={styles.fieldText}>{location}</Typography>
              </div>
            )}
          </div>
        </Box>
        <ButtonCta
          variant="text"
          arrow
          href={`events/${slug}`}
          className={styles.ctaButton}
          dataAttrs={{ 'aria-label': `View page for ${headline}` }}
        >
        View Event
        </ButtonCta>
      </Box>
    </Box>
  )
}

CardMajorEvent.propTypes = {
  headline: PropTypes.string,
  image: PropTypes.shape({
    description: PropTypes.string,
    url: PropTypes.string,
  }),
  heroImage: PropTypes.shape({
    url: PropTypes.string,
  }),
  logo: PropTypes.shape({
    url: PropTypes.string,
  }),
  slug: PropTypes.string,
  className: PropTypes.string,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  location: PropTypes.string,
  course: PropTypes.string,
  status: PropTypes.string,
}

CardMajorEvent.defaultProps = {
  className: '',
}

export default CardMajorEvent
